import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Box, Typography } from "@mui/material";
import { CarrierService } from "../../../../services/CarrierService";
import { AlertContext } from "../../../Dashboard/Dashboard";
import { handleAltEnter } from "../../../../utils/keyboardShortcutHelpers";
import StyledModal from "../../../Modals/StyledModal/StyledModal";
import PrimaryButton from "../../../Buttons/PrimaryButton/PrimaryButton";
import SecondaryButton from "../../../Buttons/SecondaryButton/SecondaryButton";

export default function CarrierProfileContactsDeleteModal({ open, setOpen, contact, contactDeleted }) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    setIsLoading(true);
    let updatedContact = { ...contact };
    updatedContact.isActive = false;

    CarrierService.UpdateCarrierContact(instance, updatedContact).then(res => {
      setIsLoading(false);
      res.isDelete = true;
      contactDeleted(res);
      setOpen(false);
    }).catch(error => {
      console.error(error);
      warning(error);
      setIsLoading(false);
    });
  };

  return (
    <Box onKeyUp={(e) => handleAltEnter(e, isLoading, handleDelete)}>
      <StyledModal
        label={"Delete Carrier Contact"}
        title={"Delete Carrier Contact"}
        open={open}
        handleClose={handleClose}
      >
        <Box sx={{ display: "flex" }}>
          <Box sx={{ marginRight: "60px" }}>
            <Typography>
              Are you sure you want to delete {contact?.name}?
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", marginTop: "30px" }}>
          <Box sx={{ marginLeft: "auto", marginRight: "20px" }}>
            <SecondaryButton
              label="Cancel"
              onClick={handleClose}
              disabled={isLoading}
            />
          </Box>
          <PrimaryButton
            label="Confirm"
            width="64px"
            onClick={handleDelete}
            isLoading={isLoading}
            disabled={isLoading}
          />
        </Box>
      </StyledModal>
    </Box>
  );
}

CarrierProfileContactsDeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  contact: PropTypes.object.isRequired,
  contactDeleted: PropTypes.func.isRequired
};